import React, { useEffect, useState } from "react";

const FloatingHearts: React.FC = () => {
  const [hearts, setHearts] = useState<
    Array<{ id: number; style: React.CSSProperties; emoji: string }>
  >([]);
  const heartEmojis = [
    "❤️" // 빨간색 하트만 사용
  ];

  const createHeart = (id: number) => {
    const opacity = Math.random() * 0.4 + 0.5; // 0.5 ~ 0.9 (50% ~ 90%)
    return {
      id,
      emoji: heartEmojis[Math.floor(Math.random() * heartEmojis.length)],
      style: {
        left: `${Math.random() * 100}%`,
        top: "-20px", // 시작 위치를 화면 위로
        fontSize: `${Math.random() * 15 + 8}px`, // 8px ~ 23px
        "--heart-opacity": opacity, // CSS 변수로 투명도 설정
        animationDelay: `${Math.random() * 4}s`, // 0 ~ 4s
        animationDuration: `${Math.random() * 5 + 8}s`, // 8 ~ 13s
        transform: `rotate(${Math.random() * 360}deg)`, // 초기 회전
      },
    };
  };

  useEffect(() => {
    // 모바일에서는 8개, 데스크톱에서는 15개로 제한
    const heartCount = window.innerWidth < 768 ? 8 : 15;
    let currentHearts = Array.from({ length: heartCount }, (_, index) =>
      createHeart(index)
    );
    setHearts(currentHearts);

    // 3초마다 랜덤하게 하트 교체
    const interval = setInterval(() => {
      setHearts((prevHearts) => {
        // 랜덤하게 1~3개의 하트 교체
        const replaceCount = Math.floor(Math.random() * 3) + 1;
        const newHearts = [...prevHearts];

        for (let i = 0; i < replaceCount; i++) {
          const replaceIndex = Math.floor(Math.random() * heartCount);
          newHearts[replaceIndex] = createHeart(replaceIndex);
        }

        return newHearts;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="floating-hearts">
      {hearts.map((heart) => (
        <div key={heart.id} className="heart" style={heart.style}>
          {heart.emoji}
        </div>
      ))}
    </div>
  );
};

export default FloatingHearts;
